export type PaperlessEobFetchRequest = {
  groupId: string;
  memberId: string;
  accessToken: string;
};

export type PaperlessEobFetchResponse = {
  summary: PaperlessEobResponseSummary;
  data: PaperlessEobResponseData;
};

export type PaperlessEobUpdateRequest = {
  action: PaperlessEobUpdateAction;
} & PaperlessEobFetchRequest;

export const PAPARLESS_EOB_UPDATE_ACTION = {
  PAPERLESS: "PAPERLESS",
  MAIL: "MAIL",
  DONT_ASK_AGAIN: "DONT_ASK_AGAIN",
} as const;

export type PaperlessEobUpdateAction =
  (typeof PAPARLESS_EOB_UPDATE_ACTION)[keyof typeof PAPARLESS_EOB_UPDATE_ACTION];

type PaperlessEobResponseSummary = {
  status_message: string;
  member_id: string;
  status_code: string;
  query_id: string;
  group_id: string;
  query: string;
  query_time: 2;
};

export type PaperlessEobResponseData = {
  dontAskAgain: boolean;
  effectiveAt: string | null;
  groupId: string;
  memberId: string;
  message: string;
  preference: string;
  isPaperlessEobEnabled: boolean;
  showDisclaimer: boolean;
  success: boolean;
};
